import { createSlice } from "@reduxjs/toolkit";

const DropDownNav = createSlice({
  name: "DropDownNav",
  initialState: {
    showStatePopUp: false,
    accDropDownList: false,
    SearchStateValue: "",
  },
  reducers: {
    toggleAccDropDownList: (state) => {
      state.accDropDownList = !state.accDropDownList;
      state.showStatePopUp = false;
    },
    toggleShowStatePopUp: (state) => {
      state.showStatePopUp = !state.showStatePopUp;
      state.accDropDownList = false;
    },
    removeNavPop: (state) => {
      state.accDropDownList = false;
      state.showStatePopUp = false;
    },
    addSearchStateValue: (state, action) => {
      state.SearchStateValue = action.payload;
    },
  },
});

export const {
  toggleAccDropDownList,
  toggleShowStatePopUp,
  addSearchStateValue,
  removeNavPop,
} = DropDownNav.actions;
export default DropDownNav.reducer;
